import { render, staticRenderFns } from "./TableAbondanedCart.vue?vue&type=template&id=04c40f26"
import script from "./TableAbondanedCart.vue?vue&type=script&lang=js"
export * from "./TableAbondanedCart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports